'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

const IS_DEV = process.env.NODE_ENV === 'development';
const COMPANY_ID = process.env.NEXT_PUBLIC_WHOP_COMPANY_ID;

type WhopQueue = {
  q: unknown[];
  t: number;
  s: string[];
  o: string;
  track: (...args: unknown[]) => void;
  setScope: (...args: string[]) => void;
  scope: (...args: unknown[]) => { track: (...args: unknown[]) => void };
};

declare global {
  interface Window {
    whop?: WhopQueue;
  }
}

export function WhopPixelProvider() {
  const pathname = usePathname();
  const initial = useRef(true);

  useEffect(() => {
    if (initial.current) {
      initial.current = false;
      return;
    }
    window.whop?.track('page');
  }, [pathname]);

  if (!COMPANY_ID || IS_DEV) return null;

  return (
    <Script id="whop-pixel" strategy="lazyOnload">
      {`!function(w,d,s,u,n,a,b){if(w[n])return;a=w[n]={q:[],t:+new Date,s:[],o:u,track:function(){a.q.push([+new Date].concat([].slice.call(arguments)))},setScope:function(){a.s=[].slice.call(arguments).filter(function(x){return typeof x==="string"});a.q.push([+new Date,"setScope"].concat(a.s))},scope:function(){var c=[].slice.call(arguments);return{track:function(){a.q.push([+new Date].concat([].slice.call(arguments)).concat([{__scope:c}]))}}}};b=d.createElement(s);b.async=1;b.src=u+"/s.js";d.getElementsByTagName(s)[0].parentNode.insertBefore(b,d.getElementsByTagName(s)[0])}(window,document,"script","https://t.whop.tw","whop");whop.setScope(${JSON.stringify(COMPANY_ID)});whop.track("page");`}
    </Script>
  );
}
